// extracted by mini-css-extract-plugin
module.exports = {"similarBooksTitle":"SimilarBookList__similarBooksTitle","subTitle":"SimilarBookList__subTitle","titleBookName":"SimilarBookList__titleBookName"};